/**
 * Collect plain text from a Lexical-serialized node tree.
 * @param {object|undefined} node
 * @returns {string}
 */
function textFromLexicalNode(node) {
  if (!node || typeof node !== 'object') return '';
  if (node.type === 'text') return String(node.text ?? '');
  if (Array.isArray(node.children)) {
    return node.children.map(textFromLexicalNode).join('');
  }
  return '';
}

/**
 * True when the scene has no non-whitespace user text in Lexical `data` (or legacy `children`).
 * @param {object} sceneItem - Scene row from API/state
 * @param {object} liveEditorJson - Full Lexical JSON (e.g. from Redux-aware merge with scene.data)
 * @returns {boolean}
 */
export default function isSceneContentEmpty(sceneItem, liveEditorJson) {
  const children = liveEditorJson?.root?.children;
  if (Array.isArray(children) && children.length > 0) {
    const text = children
      .map(textFromLexicalNode)
      .join('')
      .replace(/\u00a0/g, ' ')
      .trim();
    if (text.length > 0) return false;
  }

  const legacy = sceneItem?.children;
  if (Array.isArray(legacy) && legacy.length > 0) {
    const legacyText = legacy
      .map((c) => (c && typeof c.text === 'string' ? c.text : ''))
      .join('')
      .replace(/\u00a0/g, ' ')
      .trim();
    if (legacyText.length > 0) return false;
  }

  return true;
}
